import { describeFiltersForAssistant } from 'src/pages/jobDetails/utils/assistantFilters';
import type { AssistantPersona } from '../types';
import { GREETING, HERO, INTRO } from './launchpad';
import {
  BOTTOM_BAR_PAGES,
  EXPLORE_SUGGESTIONS,
  FOCUS_SCREENS,
  GENERAL_SUGGESTIONS,
  PAGE_HINTS,
  TRY_SAYING,
} from './pages';

const APPLICANT_REVIEW = /^\/applicant-review\/(?!posting-preview)[^/]+/;

/** Abekus AI for employers: recruiters and hiring managers (backend `employer/`). */
const EMPLOYER_PERSONA: AssistantPersona = {
  audience: 'employer',
  focusScreens: FOCUS_SCREENS,
  bottomBarPages: BOTTOM_BAR_PAGES,
  // Applicant review's shortlist / reject / next bar.
  actionBarPages: [APPLICANT_REVIEW],
  pageHints: PAGE_HINTS,
  generalSuggestions: GENERAL_SUGGESTIONS,
  exploreSuggestions: EXPLORE_SUGGESTIONS,
  tryHints: TRY_SAYING,
  launchpad: { intro: INTRO, hero: HERO },
  greeting: GREETING,
  // The company the app has active, and Applicant review's filters, which
  // live in the store rather than the URL: the assistant keeps the ones the
  // employer still wants when changing them.
  pageState: (state, pathname) => {
    const page: Record<string, string> = {};
    if (state.employer.activeOrgId) page.org_id = state.employer.activeOrgId;
    const filters = state.applicantReview.currentFilters;
    if (APPLICANT_REVIEW.test(pathname) && filters) {
      const words = describeFiltersForAssistant(
        filters,
        state.applicantReview.jobData?.job?.job_type,
      );
      page.filters_on_screen = Object.keys(words).length
        ? JSON.stringify(words)
        : "none: the page's default view";
    }
    return page;
  },
};

export default EMPLOYER_PERSONA;
